var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MainContent,{attrs:{"title":"Editar indumentaria"}},[_c(_setup.FormIndumentaria)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }